import { Box } from '@mui/material';
import styled from 'styled-components';

export const ErrorBox = styled(Box)`
  max-width: 300px;

  p {
    margin-bottom: 1rem;
  }
`;
